import { store } from '../store'

export default class SymbolService {
    async getSymbols (params) {
        return await store.dispatch('symbol/getSymbols', {
            _data: params
        })
    }
}
